(function() {
  var label = document.documentElement.lang === 'zh-TW' ? '聯絡 WhatsApp' : 'Contact on WhatsApp';
  (function setAria() {
    var btn = document.querySelector('.gty-wacb-button');
    if (btn && !btn.getAttribute('aria-label')) {
      btn.setAttribute('aria-label', label);
      return true;
    }
    return !!btn;
  })() || new MutationObserver(function(_records, obs) {
    if (document.querySelector('.gty-wacb-button')) {
      setAria();
      obs.disconnect();
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
